import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isUpdateDocumentRequestFailure(document) {
      const result = getState().find(
        (result) => result.document.uuid === document.uuid,
      );

      return result ? result.request.isFailure : false;
    },
    isUpdateDocumentRequestPending(document) {
      const result = getState().find(
        (result) => result.document.uuid === document.uuid,
      );

      return result ? result.request.isPending : false;
    },
    isUpdateDocumentRequestSuccess(document) {
      const result = getState().find(
        (result) => result.document.uuid === document.uuid,
      );

      return result ? result.request.isSuccessful : false;
    },
  };
}

export { createSelector };
